import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import SectionSubHeader from "../sectionSubHeader";
import SectionHeader from "../sectionHeader";
import CustomButton from "../CustomButton";
import { Link } from "react-router-dom";
import { BsArrowRight } from "react-icons/bs";

const WorkCulture = () => {
  return (
    <div className="section-bg work-culture">
      <Container className="" >
      <SectionHeader mainText1="VOLTO WORK CULTURE"  />
        <Row>
        
          <Col lg={7}>
           
            <SectionSubHeader headerText="Building a Collaborative and Inclusive Work Culture" />
          </Col>
          <Col lg={1}></Col>
          <Col lg={4}> 
           <p>At VOLTO, we foster a collaborative and inclusive culture where creativity, growth, and teamwork thrive.</p>
          
          </Col>
        </Row>
        <Row className="cultures">
            <Col lg={3} className="pr-96">
               <img src="images/diversity.svg" alt="Diversity and Inclusion" />
               <h3>Diversity and Inclusion</h3>
               <p>At VOLTO, we promote a diverse and inclusive environment where everyone can succeed, regardless of race, gender, religion, age, or ability.</p>
            </Col>
            <Col lg={3} className="pr-96">
               <img src="images/commitment.svg" alt="Our Commitment" />
               <h3>Our Commitment</h3>
               <p>VOLTO is committed to investing in you at every stage of your career and offering the finest, most direct route to broad and comprehensive business skills.</p>
            </Col>
            <Col lg={3} className="pr-96">
               <img src="images/work-life.svg" alt="Work-life Harmony" />
               <h3>Work-life Harmony</h3>
               <p>VOLTO is committed to supporting our staff in achieving balanced, rewarding careers and full lives.</p>
            </Col>
            <Col lg={3} className="pr-96">
               <img src="images/growth-everyone.svg" alt="Growth for Everyone" />
               <h3>Growth for Everyone</h3>
               <p>Our success comes from our people. Their innovation drives us forward, creating exciting opportunities for your career growth.</p>
            </Col>
          </Row>
      </Container>
       
    </div>
  );
};

export default WorkCulture;
